/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * Extracts entities from the given text.
 *
 * @param text The text to extract entities from.
 * @returns Mentioned entities in the given text.
 */
export const extractPatternEntities = (text: string): string[] => {
    if (text.indexOf('{') === -1) {
        return [];
    }
    const newText = text.slice(text.indexOf('{') + 1);
    const indexOfClosingCurlyBracket = newText.indexOf('}');

    const res = extractPatternEntities(newText.slice(indexOfClosingCurlyBracket + 1));
    res.push(newText.slice(0, indexOfClosingCurlyBracket));

    return res;
};
